import React, { Component, useState } from 'react'
import {useDateSegment, useLocale, useTimeField} from 'react-aria';
import {useTimeFieldState} from 'react-stately';
import {parseDate, CalendarDate, Time, parseAbsoluteToLocal} from '@internationalized/date';

import {Button, Label, ListBox, ListBoxItem, Popover, Select, SelectValue} from 'react-aria-components';
import type {ListBoxItemProps} from 'react-aria-components';
import ChevronUpDownIcon from '@spectrum-icons/workflow/ChevronUpDown';
import CheckIcon from '@spectrum-icons/workflow/Checkmark';
import moment from 'moment'

export function PPCTimeField(props) {
  let { locale } = useLocale();
  let customFieldProps = {...props}

  const  onChange=((event) => {
      let totalTime = 0;
      
      if(event.hour > 0) {
          totalTime = (event.hour*60);
      }
      totalTime += (event.minute);
      if(props?.onChange) {
          props.onChange(props?.name, totalTime);
      }
      
  })
  
  let totalHours = 0;
  let totalMinutes = 0;
  if(props.defaultValue) {
      totalHours = Math.floor(parseInt(props.defaultValue) / 60);
      totalMinutes = parseInt(props.defaultValue) - (totalHours * 60) ;
  }
  
  customFieldProps.onChange = onChange;
  customFieldProps.defaultValue = new Time(totalHours,totalMinutes);
  customFieldProps.totalHours = totalHours;
  customFieldProps.totalMinutes = totalMinutes;
  let state = useTimeFieldState({
      defaultValue: customFieldProps.defaultValue,
    ...customFieldProps,
    locale
  });
  
  
  let ref = React.useRef(null);
  let { labelProps, fieldProps } = useTimeField(props, state, ref);
  
  
  return (
    <div className="wrapper">
      <span {...labelProps}>{props.label}</span>
      <div {...fieldProps} ref={ref} className="field flex">
        {state.segments.map((segment, i) => (
          <DateSegment key={i} segment={segment} state={state} index={i} props={props} />
        ))}
        {state.isInvalid &&
          <span aria-hidden="true">🚫</span>}
      </div>
    </div>
  );
}

// Note: this component is the same as in the useDateField docs.
function DateSegment({key, segment, state, index, props }) {
  let ref = React.useRef(null);
  let { segmentProps } = useDateSegment(segment, state, ref);
  const {segments} = state;
    if(segments[index]['type'] == "minute" && Array.isArray(props?.interval) ){
        return (<GetMinuteInterval key={index} segment={segment} state={state} index={index} interval={props?.interval}  />)
    }
  return (
    <div
      {...segmentProps}
      ref={ref}
      className={`segment px-0.1 tabular-nums  p-1 focus:bg-violet-700 focus:text-white caret-transparent placeholder-shown:italic ${segment.isPlaceholder ? 'placeholder' : ''}`+
      ((segmentProps['aria-valuetext']) ? 'border-1 border rounded-md' : '')}
    >
      {segment.text}
      {segment.type == 'hour' && props?.lblHour && 
        <span className="ml-2">{props?.lblHour}</span>
      }
      {segment.type == 'minute' && props?.lblMinute && 
        <span className="ml-2">{props?.lblMinute}</span>
      }
      
    </div>
  );
}

function setMinute(selectedKey, state, interval) {
    if(interval) {
        state.setSegment('minute', interval[selectedKey].value);
    }
}
function GetMinuteInterval({key, segment, state, index, interval }) {
  let ref = React.useRef(null);
  let { segmentProps } = useDateSegment(segment, state, ref);
  let { labelProps, fieldProps } = useTimeField({}, state, ref);
  const {segments} = state;
    //console.info("props", props);
    let selectedIndex = 0;
    if(state && state.timeValue && state.timeValue.minute > 0 && Array.isArray(interval) && interval.length > 0) {
      for(let i in interval) {
          if(state.timeValue.minute == interval[i].value) {
            selectedIndex = parseInt(i);
            break;      
          }
      }  
    } 

  
  return (
      <Select 
      >
        <Button className="flex items-center cursor-default border-0 bg-white bg-opacity-90 pressed:bg-opacity-100 transition text-base text-left leading-normal ">
          <SelectValue className="flex-1 truncate placeholder-shown:italic" />
        </Button>
        <Popover className="max-h-60 w-[--trigger-width] overflow-auto rounded-md bg-white text-base shadow-lg ring-1 ring-black/5 entering:animate-in entering:fade-in exiting:animate-out exiting:fade-out">
          <ListBox className="outline-none p-1" >
        {Array.isArray(interval) && interval.length > 0 && interval.map((intervalItem, index) => {
            return (<StatusItem id={index} textValue={intervalItem.label}>
              {intervalItem.label}
            </StatusItem>);
            
        })}
              </ListBox>
        </Popover>
      </Select>
  );
}   


function StatusItem({...props}) {
  return (
    <ListBoxItem
      {...props}
      className="group flex items-center gap-2 cursor-default select-none py-2 px-4 outline-none rounded text-gray-900 focus:bg-rose-600 focus:text-white"
    >
      {({ isSelected }) => (
        <>
          <span className="flex-1 flex items-center gap-2 truncate font-normal group-selected:font-medium">
            {props.children}
          </span>
          <span className="w-5 flex items-center text-rose-600 group-focus:text-white">
            {isSelected && <CheckIcon size="S" />}
          </span>
        </>
      )}
    </ListBoxItem>
  );
}

function Status({ className }: { className: string }) {
  return (
    <span
      className={`w-3 h-3 rounded-full border border-solid border-white ${className}`}
    />
  );
}


